<mat-card
  class="on-hold-content__card  top-card summary-card mat-elevation-z0 black-border-color"
>
  <div class="upper-space less-mat-form-field-bottom-padding">
    <textarea-input
      [class.error-input]="subProject.onHoldReason?.length <= 0"
      [subtitle]="'Reden waarom on hold'"
      [placeholder]="''"
      [initContent]="subProject.onHoldReason"
      [sensitive]="true"
      (answer)="onHoldReasonChanged($event)"
    >
    </textarea-input>
    <p class="error" *ngIf="subProject.onHoldReason?.length <= 0">
      On hold reden mag niet leeg zijn
    </p>
    <div
      *ngIf="subProject.putOnHold != null"
      class="registered-action-display-container d-flex"
    >
      <div>
        <i>On hold geplaatst door</i>
      </div>
      <div class="ml-3">
        <i>{{
          subProject.putOnHold.by?.firstName
            | personName: subProject.putOnHold.by?.lastName
        }}</i>
      </div>
      <div class="ml-3">
        <i>{{
          subProject.putOnHold.date | formatDate: '-':'dd/MM/yyyy HH:mm'
        }}</i>
      </div>
    </div>
  </div>
  <div class="more-upper-space less-mat-form-field-bottom-padding">
    <textarea-input
      [subtitle]="'Opvolging van deze job (datum en naam)'"
      [placeholder]="''"
      [initContent]="subProject.onHoldHandling"
      [sensitive]="true"
      (answer)="onHoldHandlingChanged($event)"
    >
    </textarea-input>
    <div class="registered-action-display-container">
      <div>
        <mat-checkbox
          [(ngModel)]="onHoldCheckboxModel"
          (ngModelChange)="onHoldCheckboxModelChanged()"
          ><i>Afgehandeld</i></mat-checkbox
        >
      </div>
      <div class="align-with-registration-checkbox">
        <i>{{
          subProject.onHoldHandled?.by?.firstName
            | personName: subProject.onHoldHandled?.by?.lastName
        }}</i>
      </div>
      <div class="align-with-registration-checkbox">
        <i>{{
          subProject.onHoldHandled?.date | formatDate: '':'dd/MM/yyyy HH:mm'
        }}</i>
      </div>
    </div>
  </div>
</mat-card>
